//
// Scrolling FX To # Anchor
//

var fn_scroll_to = function () {

    document.querySelectorAll('a[href^="#"]:not(.panels__navitem)').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: "smooth"
            });
        });
    });

};
